"use client";

import { Check } from "lucide-react";
import { Button } from "@/ui";

export interface CTAFeatureListProps {
  title?: string;
  subtitle?: string;
  features?: string[];
  primaryLabel?: string;
  secondaryLabel?: string;
  onPrimaryClick?: () => void;
  onSecondaryClick?: () => void;
}

const defaultFeatures = [
  "Chef's seasonal specials",
  "Handcrafted cocktails",
  "Private dining available",
];

export default function CTAFeatureList({
  title = "Make it a memorable evening",
  subtitle = "Reserve your spot and enjoy handcrafted courses and curated wines.",
  features = defaultFeatures,
  primaryLabel = "Reserve Now",
  secondaryLabel = "Contact Us",
  onPrimaryClick,
  onSecondaryClick,
}: CTAFeatureListProps) {
  return (
    <section className="max-w-6xl mx-auto px-6">
      <div className="rounded-3xl border border-black/10 bg-white/50 backdrop-blur p-8 md:p-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
          <div className="md:col-span-2">
            <h3 className="text-3xl md:text-5xl font-bold text-black mb-3">
              {title}
            </h3>
            <p className="text-black/70 text-lg md:text-xl mb-6">{subtitle}</p>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {features.map((feat) => (
                <li
                  key={feat}
                  className="flex items-center gap-2 text-black/80"
                >
                  <Check className="w-5 h-5 text-black" aria-hidden="true" />
                  <span>{feat}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="flex flex-col sm:flex-row md:flex-col gap-4 justify-center md:justify-start">
            <Button
              type="button"
              variant="primary"
              size="lg"
              onClick={onPrimaryClick}
              className="rounded-full"
            >
              {primaryLabel}
            </Button>
            <Button
              type="button"
              variant="secondary"
              size="lg"
              onClick={onSecondaryClick}
              className="rounded-full"
            >
              {secondaryLabel}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
